import { useState, useEffect } from "react";

export const useAllArticles = (limit = null) => {
  const [articles, setArticles] = useState([]);
  const [filteredArticles, setFilteredArticles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");
  // Variables d'environnement sécurisées
  /* eslint-disable no-undef */
  const COSMIC_BUCKET = process.env.NEXT_PUBLIC_COSMIC_BUCKET_SLUG;
  const COSMIC_READ_KEY = process.env.NEXT_PUBLIC_COSMIC_READ_KEY;
  /* eslint-enable no-undef */

  // URL de base selon l'environnement
  const API_BASE_URL = "https://api.cosmicjs.com";

  useEffect(() => {
    // Fetch des articles et des catégories depuis l'API
    const fetchData = async () => {
      try {
        // Fetch des articles
        const articlesResponse = await fetch(
          `${API_BASE_URL}/v3/buckets/${COSMIC_BUCKET}/objects?read_key=${COSMIC_READ_KEY}&query=${encodeURIComponent(
            '{"type":"posts"}'
          )}&props=id,title,metadata&depth=1`
        );
        const listArticles = await articlesResponse.json();

        // Fetch des catégories
        const categoriesResponse = await fetch(
          `${API_BASE_URL}/v3/buckets/${COSMIC_BUCKET}/objects?read_key=${COSMIC_READ_KEY}&query=${encodeURIComponent(
            '{"type":"categories"}'
          )}&props=id,title`
        );
        const listCategories = await categoriesResponse.json();

        if (listArticles.objects) {
          // Trier les articles par date de publication (DESC)
          const sortedArticles = listArticles.objects.sort((a, b) => {
            const dateA = new Date(a.metadata?.date_de_publication);
            const dateB = new Date(b.metadata?.date_de_publication);
            return dateB - dateA; // Ordre décroissant (plus récent en premier)
          });

          // Appliquer la limite si spécifiée
          const limitedArticles = limit
            ? sortedArticles.slice(0, limit)
            : sortedArticles;

          setArticles(limitedArticles);
          setFilteredArticles(limitedArticles);
        }

        if (listCategories.objects) {
          const categoryNames = listCategories.objects.map((cat) => cat.title);
          setCategories(categoryNames);
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des données:", error);
      }
    };
    fetchData();
  }, []);

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    if (category === "all") {
      setFilteredArticles(articles);
    } else {
      const filtered = articles.filter((article) => {
        const theme = article.metadata?.theme;

        // Si theme est un objet (relation), chercher par titre
        if (typeof theme === "object" && theme?.title) {
          return theme.title === category;
        }

        // Si theme est un tableau d'objets
        if (Array.isArray(theme)) {
          return theme.some((t) => t.title === category || t === category);
        }

        // Si theme est une chaîne simple
        return theme === category;
      });

      // Garder l'ordre de tri par date après filtrage
      const sortedFiltered = filtered.sort((a, b) => {
        const dateA = new Date(a.metadata?.date_de_publication);
        const dateB = new Date(b.metadata?.date_de_publication);
        return dateB - dateA;
      });

      setFilteredArticles(sortedFiltered);
    }
  };

  return {
    articles,
    filteredArticles,
    categories,
    selectedCategory,
    handleCategoryChange,
  };
};
